import { render } from "./remaining-wlc-row.vue?vue&type=template&id=4c8a189a"
import script from "./remaining-wlc-row.vue?vue&type=script&lang=js"
export * from "./remaining-wlc-row.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__